var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script-editor',{model:{value:(_vm.scripts),callback:function ($$v) {_vm.scripts=$$v},expression:"scripts"}})}
var staticRenderFns = []

export { render, staticRenderFns }